import React, { ReactElement } from 'react';

// Utils
import { isSubscribed } from '../../../userUtil';

// Constants
import { ELEMENT_COUNT_WARNING_START } from '../../../elementCount/elementCountConstants';

// Types
import { ImMNCurrentUser, MNCurrentUser } from '../../../currentUserSelector';

type PlanStatusTitleProps = {
    currentUser: ImMNCurrentUser | MNCurrentUser;
    contentTotalCount: number;
    contentTotalLimit: number;
};

const PlanStatusTitle = ({ currentUser, contentTotalCount, contentTotalLimit }: PlanStatusTitleProps): ReactElement => {
    if (isSubscribed(currentUser)) {
        return (
            <span className="plan-status">
                You&apos;re on the <span className="plan-name">professional</span> plan
            </span>
        );
    }

    if (contentTotalCount >= contentTotalLimit) {
        return (
            <span className="plan-status">
                <span className="plan-name">Your workspace is full</span>
            </span>
        );
    }

    if (contentTotalCount >= contentTotalLimit - ELEMENT_COUNT_WARNING_START) {
        return (
            <span className="plan-status">
                <span className="plan-name">Your workspace is almost full</span>
            </span>
        );
    }

    return (
        <span className="plan-status">
            You&apos;re on the <span className="plan-name">free</span> plan
        </span>
    );
};

export default PlanStatusTitle;
